/* disable-ts-etc */
import { AppProps } from 'src/app/App';
import { getColorName } from '../../../../helpers/color';
import { SelectedNodes } from '../types';

const getNames = ({ selectedNodes }: { selectedNodes: SelectedNodes }) =>
  selectedNodes.map(({ name }) => name.trim());

const nameForTealium = ({ brandName, abbrNameForTealium }: AppProps) => {
  return brandName === 'gapfs' ? brandName : abbrNameForTealium;
};

export default (props: AppProps): string =>
  [
    nameForTealium(props),
    'browse',
    ...getNames(props),
    props?.subcategoryName || getColorName(props?.params?.color),
  ]
    .filter((element) => !!element)
    .join(':');
